var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8059 11.9421C13.977 11.9421 16.5477 9.46322 16.5477 6.40539C16.5477 3.34757 13.977 0.868713 10.8059 0.868713C7.63487 0.868713 5.06421 3.34757 5.06421 6.40539C5.06421 9.46322 7.63487 11.9421 10.8059 11.9421Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70082 19.6332C1.69411 19.2325 1.78457 18.8358 1.96505 18.4749C2.36196 17.9635 2.86281 17.5354 3.43693 17.2168C4.01106 16.8982 4.64646 16.6956 5.30442 16.6216C6.23109 16.4341 7.17042 16.3103 8.11527 16.2509C9.86956 16.1004 11.6342 16.1004 13.3885 16.2509C14.3341 16.3092 15.2738 16.4371 16.1993 16.6332C17.4846 16.888 19.0342 17.3977 19.5867 18.5097C19.7684 18.8706 19.8628 19.2667 19.8628 19.668C19.8628 20.0692 19.7684 20.4653 19.5867 20.8263C19.0342 21.9846 17.4846 22.4479 16.1993 22.6911C15.2743 22.8919 14.3345 23.0236 13.3885 23.085C11.962 23.1969 10.5293 23.2162 9.10019 23.1429C8.77021 23.1543 8.44 23.131 8.11527 23.0734C7.17265 23.0169 6.2365 22.8851 5.31645 22.6795C4.64374 22.6291 3.99064 22.4371 3.40328 22.1169C2.81592 21.7967 2.3086 21.3561 1.91703 20.8263C1.74836 20.4506 1.67428 20.0417 1.70082 19.6332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavProfile);
export default __webpack_public_path__ + "static/media/nav-profile.26e8c00de37d47b2b2ba3bc99a851f18.svg";
export { ForwardRef as ReactComponent };